import React, { use, useEffect, useMemo } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  getClaimDetails,
  prepareTakafulMotorPremiumCalInputs,
} from "../../../utils/takafulHelpers";
import { getLicenseVehicle, getQuote } from "../../../features/product";
import { capitalize, getExcelDate } from "../../../utils/commonHelper";
import { Button } from "react-bootstrap";
import { Loader } from "../../common/loader";
import { useTranslation } from "react-i18next";

// Utility to convert file to base64
const toBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const base64 = reader.result.split(",")[1]; // Remove metadata
      resolve(base64);
    };
    reader.onerror = (error) => reject(error);
  });

const initialValues = {
  title: "",
  first_name: "",
  last_name: "",
  email: "",
  mobile_no: "",
  license_file_base64: "",
  license_file_name: "",
  resident_id_file_base64: "",
  resident_id_file_name: "",
  mulkiya_file_base64: "",
  mulkiya_file_name: "",
};

const validationSchema = Yup.object({
  title: Yup.string().required("Required"),
  first_name: Yup.string().required("Required"),
  last_name: Yup.string().required("Required"),
  email: Yup.string().email("Invalid email").required("Required"),
  mobile_no: Yup.string()
    .matches(/^\d{6,15}$/, "Enter 6–15 digits")
    .required("Required"),
  license_file_base64: Yup.string().required("License file is required"),
  resident_id_file_base64: Yup.string().required(
    "Resident ID file is required"
  ),
  mulkiya_file_base64: Yup.string().required("Resident ID file is required"),
});

const TakafulMotorPersonalDetailForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const planData = useMemo(
    () => location?.state?.data || {},
    [location?.state]
  );
  const { vehicleData } = useSelector((state) => state.product);
  const quoteLoader = useSelector((state) => state.product.quoteLoader);

  const { t } = useTranslation();
  useEffect(() => {
  }, [planData]);
  useEffect(() => {
    // console.log({ vehicleData });
    if (!vehicleData) {
      // console.log({
      //   licence_no: planData?.extracted_data?.licenseNo || "82373664",
      //   plate_no: planData?.extracted_data?.plateNumber,
      //   plate_char: planData?.extracted_data?.plateCode,
      //   plate_type: planData?.extracted_data?.plateType || "1",
      // });

      dispatch(
        getLicenseVehicle({
          licence_no: planData?.extracted_data?.licenseNo || "82373664",
          plate_no: planData?.extracted_data?.plateNumber,
          plate_char: planData?.extracted_data?.plateCode,
          plate_type: planData?.extracted_data?.plateType || "1",
        })
      );
    }
  }, [vehicleData]);

  const inputData = prepareTakafulMotorPremiumCalInputs(vehicleData);

  if (quoteLoader || !vehicleData || !planData) {
    return <Loader type="logo-gif" />;
  }

  return (
    <div className="container my-5">
      <div className="policy-formBox why-us-form">
        <h3>{t("motorPersonalForm.title")}</h3>        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={(values) => {
            let customerData = {
              insured_dob: inputData?.customer?.insured_dob, // <DateofBirth> from License info
              civil_resident_id: inputData?.customer?.civil_resident_id, //<LicenseNumber> from licene info
              title: values?.title, // from webportal user-input
              first_name: values?.first_name, // from web portal user-input
              last_name: values?.last_name, // from web portal user-input
              email: values?.email, // from web portal user-input
              mobile_no: values?.mobile_no, // from web portal user-input
              cr_no: "0",
              governate: "Muscut",
              wilayat: "Al Amarat",
              address: "TN",
              nationality: "INDIA",
              customer_type: "Individual",
              do_you_have_VAT: "No",
              vat_reg_no: "0",
            };

            let claimDetails = getClaimDetails(vehicleData);

            let plan_type;
            if (
              vehicleData?.ropVehicle?.Body?.GetVehicleValuationByPlateResponse?.GetVehicleValuationByPlateResult?.VehicleInfo?.InsuranceTypeDesc.toLowerCase().includes(
                "third"
              )
            ) {
              plan_type = "Third party";
            } else if (
              vehicleData?.ropVehicle?.Body?.GetVehicleValuationByPlateResponse?.GetVehicleValuationByPlateResult?.VehicleInfo?.InsuranceTypeDesc.toLowerCase().includes(
                "comprehensive"
              )
            ) {
              plan_type = "Comprehensive";
            }
            console.log(
              "plate_category ::",
              vehicleData?.ropVehicle?.Body?.GetVehicleValuationByPlateResponse
                ?.GetVehicleValuationByPlateResult?.VehicleInfo
                ?.RegistraionTypeDesc
            );

            const apiRequestData = {
              ...planData?.extracted_data,
              planData,
              premium_value: planData?.premium_value,
              premium_currency: planData?.premium_currency,
              insurance_company_product_mapping_id:
                planData?.insurance_company_product_mapping_id,
              company_id: planData?.company_id,
              vehicleChassisNumber:
                planData?.extracted_data?.vehicleChassisNumber,
              ...inputData,
              customer: customerData,
              plate_category: capitalize(
                vehicleData?.ropVehicle?.Body?.GetVehicleValuationByPlateResponse?.GetVehicleValuationByPlateResult?.VehicleInfo?.RegistraionTypeDesc?.toLowerCase()
              ),
              insured_license_expire_date: getExcelDate(
                vehicleData?.ropLicense?.Body?.GetLicenseInfoResponse
                  ?.GetLicenseInfoResult?.DateofExpiry
              ), // <DateofExpiry> from license info
              insured_license_issue_date:
                vehicleData?.ropLicense?.Body?.GetLicenseInfoResponse
                  ?.GetLicenseInfoResult?.DateFirstIssued, // <DateFirstIssued> from license info
              mulkiya_date: getExcelDate(
                vehicleData?.ropVehicle?.Body
                  ?.GetVehicleValuationByPlateResponse
                  ?.GetVehicleValuationByPlateResult?.VehicleInfo
                  ?.RegistrationEndDate
              ), // <RegistrationEndDate> from auto data
              vehicle_engine_no_rop:
                vehicleData?.ropVehicle?.Body
                  ?.GetVehicleValuationByPlateResponse
                  ?.GetVehicleValuationByPlateResult?.VehicleInfo?.EngineNumber, // <EngineNumber> number from Auto data
              vehicle_color:
                vehicleData?.ropVehicle?.Body
                  ?.GetVehicleValuationByPlateResponse
                  ?.GetVehicleValuationByPlateResult?.VehicleInfo?.ColorDesc, // <ColorDesc> from auto data
              prev_policy_type: plan_type, // pick this value from auto data <InsuranceTypeDesc> pick only words Third party or Comprehensive
              prev_vechile_value: plan_type === "Third party" ? "" : 0, // blank if third party. If Comphrehensive pick value from 2.GIG_Veh_Valuation
              previous_insurance:
                vehicleData?.ropVehicle?.Body
                  ?.GetVehicleValuationByPlateResponse
                  ?.GetVehicleValuationByPlateResult?.VehicleInfo
                  ?.InsuranceCompanyName, //<InsuranceCompanyName> from auto data
              ...claimDetails,
              license_file_name: values.license_file_name,
              license_file_base64: values.license_file_base64,
              resident_id_file_name: values.resident_id_file_name,
              resident_id_file_base64: values.resident_id_file_base64,
              mulkiya_file_name: values.mulkiya_file_name,
              mulkiya_file_base64: values.mulkiya_file_base64,
              add_drivers: "No",
              additional_drivers: [],
            };

            dispatch(getQuote(apiRequestData)).then((res) => {
              // console.log(res);
              navigate("/checkout", { state: { existingData: res.payload } });
            });
          }}
        >
          {({ setFieldValue }) => (
            <Form>
              <div className="row">
                <div className="col-md-6 col-lg-4 col-sm-6 col-12">
                  <div className="form-group mb-2">
                    <label className="form-label">
                      {t("motorPersonalForm.fields.title")}
                    </label>
                    <Field
                      as="select"
                      name="title"
                      className="form-select form-control element-style"
                    >
                      <option value="">
                        {t("motorPersonalForm.placeholders.select")}
                      </option>
                      <option value="Mr.">Mr.</option>
                      <option value="Ms.">Ms.</option>
                      <option value="Mrs.">Mrs.</option>
                    </Field>
                    <div className="text-danger small">
                      <ErrorMessage name="title" />
                    </div>
                  </div>
                </div>

                <div className="col-md-6 col-lg-4 col-sm-6 col-12">
                  <div className="form-group mb-2">
                    <label className="form-label">
                      {t("motorPersonalForm.fields.first_name")}
                    </label>
                    <Field
                      name="first_name"
                      className="element-style"
                      placeholder={t("motorPersonalForm.placeholders.first_name")}
                    />
                    <div className="text-danger small">
                      <ErrorMessage name="first_name" />
                    </div>
                  </div>
                </div>

                <div className="col-md-6 col-lg-4 col-sm-6 col-12">
                  <div className="form-group mb-2">
                    <label className="form-label">
                      {t("motorPersonalForm.fields.last_name")}
                    </label>
                    <Field
                      name="last_name"
                      className="element-style"
                      placeholder={t("motorPersonalForm.placeholders.last_name")}
                    />
                    <div className="text-danger small">
                      <ErrorMessage name="last_name" />
                    </div>
                  </div>
                </div>

                <div className="col-md-6 col-sm-6 col-12">
                  <div className="form-group mb-2">
                    <label className="form-label">
                      {t("motorPersonalForm.fields.email")}
                    </label>
                    <Field
                      name="email"
                      type="email"
                      className="element-style"
                      placeholder={t("motorPersonalForm.placeholders.email")}
                    />
                    <div className="text-danger small">
                      <ErrorMessage name="email" />
                    </div>
                  </div>
                </div>

                <div className="col-md-6 col-sm-6 col-12">
                  <div className="form-group mb-2">
                    <label className="form-label">
                      {t("motorPersonalForm.fields.mobile_no")}
                    </label>
                    <Field
                      name="mobile_no"
                      className="element-style"
                      placeholder={t("motorPersonalForm.placeholders.mobile_no")}
                    />
                    <div className="text-danger small">
                      <ErrorMessage name="mobile_no" />
                    </div>
                  </div>
                </div>

                <div className="col-md-6 col-lg-4 col-sm-6 col-12">
                  <div className="form-group mb-2">
                    <label className="form-label">
                      {t("motorPersonalForm.fields.license_file")}
                    </label>
                    <input
                      type="file"
                      className="element-style"
                      accept=".pdf,.png,.jpg,.jpeg"
                      onChange={async (e) => {
                        const file = e.currentTarget.files[0];
                        if (file) {
                          const base64 = await toBase64(file);
                          setFieldValue("license_file_base64", base64);
                          setFieldValue("license_file_name", file.name);
                        }
                      }}
                    />
                    <div className="text-danger small">
                      <ErrorMessage name="license_file_base64" />
                    </div>
                  </div>
                </div>

                <div className="col-md-6 col-lg-4 col-sm-6 col-12">
                  <div className="form-group mb-2">
                    <label className="form-label">
                      {t("motorPersonalForm.fields.resident_id_file")}
                    </label>
                    <input
                      type="file"
                      className="element-style"
                      accept=".pdf,.png,.jpg,.jpeg"
                      onChange={async (e) => {
                        const file = e.currentTarget.files[0];
                        if (file) {
                          const base64 = await toBase64(file);
                          setFieldValue("resident_id_file_base64", base64);
                          setFieldValue("resident_id_file_name", file.name);
                        }
                      }}
                    />
                    <div className="text-danger small">
                      <ErrorMessage name="resident_id_file_base64" />
                    </div>
                  </div>
                </div>

                <div className="col-md-6 col-lg-4 col-sm-6 col-12">
                  <div className="form-group mb-2">
                    <label className="form-label">
                      {t("motorPersonalForm.fields.mulkiya_file")}
                    </label>
                    <input
                      type="file"
                      className="element-style"
                      accept=".pdf,.png,.jpg,.jpeg"
                      onChange={async (e) => {
                        const file = e.currentTarget.files[0];
                        if (file) {
                          const base64 = await toBase64(file);
                          setFieldValue("mulkiya_file_base64", base64);
                          setFieldValue("mulkiya_file_name", file.name);
                        }
                      }}
                    />
                    <div className="text-danger small">
                      <ErrorMessage name="mulkiya_file_base64" />
                    </div>
                  </div>
                </div>

                <div className="col-md-12">
                  <Button type="submit" className="h-btn mt-2">
                    {t("motorPersonalForm.buttons.submit")}
                  </Button>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default TakafulMotorPersonalDetailForm;
